import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import BottomBar from '../components/BottomBar';
import back from '../assets/icon/back.svg';
import './LinkingTest.css';

const bismillahRegex = /^بِسْمِ\s*[ٱا]للَّهِ\s*[ٱا]لرَّحْمَٰنِ\s*[ٱا]لرَّحِيمِ/;

const LinkingTest = () => {
  const [searchParams] = useSearchParams();
    const navigate = useNavigate();
  const surahParam = searchParams.get('surah');
  const modeParam = searchParams.get('mode') || 'full';
  const startParam = parseInt(searchParams.get('start'), 10);
  const endParam = parseInt(searchParams.get('end'), 10);
  const [questions, setQuestions] = useState([]);
  const [current, setCurrent] = useState(0);
  const [selected, setSelected] = useState('');
  const [result, setResult] = useState(null);
  const [surahName, setSurahName] = useState('');
  const [showOptions, setShowOptions] = useState(false);


  useEffect(() => {
    if (!surahParam) return;
    fetch(`https://api.alquran.cloud/v1/surah/${surahParam}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.code === 200) {
            let ayahs = data.data.ayahs;
            if (modeParam === 'range') {
              if (
                !isNaN(startParam) &&
                !isNaN(endParam) &&
                startParam >= 1 &&
                endParam <= ayahs.length &&
                startParam <= endParam
              ) {
                ayahs = ayahs.filter(
                  (a) =>
                    a.numberInSurah >= startParam && a.numberInSurah <= endParam
                );
              }
            }
          setSurahName(data.data.name);
          const pages = {};
          ayahs.forEach((a) => {
            if (!pages[a.page]) pages[a.page] = [];
            pages[a.page].push(a);
          });
          const pageNumbers = Object.keys(pages)
            .map((n) => parseInt(n, 10))
            .sort((a, b) => a - b);
          const qs = [];
          for (let i = 0; i < pageNumbers.length - 1; i++) {
            const lastAyah = pages[pageNumbers[i]][pages[pageNumbers[i]].length - 1];
            const nextAyah = pages[pageNumbers[i + 1]][0];
            const wrong = getRandomWrong(ayahs, nextAyah.number, 3);
            const options = shuffle([nextAyah, ...wrong]).map((o) => {
              let text = o.text;
              if (o.numberInSurah === 1 && bismillahRegex.test(text)) {
                const without = text.replace(bismillahRegex, '').trim();
                if (without) text = without;
              }
              return { id: o.number, text };
            });
            qs.push({
              question: lastAyah.text,
              correct: nextAyah.number,
              options,
            });
          }
          setQuestions(qs);
        }
      })
      .catch((err) => console.error(err));
    }, [surahParam, modeParam, startParam, endParam]);

  const shuffle = (arr) => {
    const array = [...arr];
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  };

  const getRandomWrong = (arr, excludeNumber, count) => {
    const filtered = arr.filter((a) => a.number !== excludeNumber);
    const wrong = [];
    while (wrong.length < count && filtered.length > 0) {
      const idx = Math.floor(Math.random() * filtered.length);
      wrong.push(filtered[idx]);
      filtered.splice(idx, 1);
    }
    return wrong;
  };

  const handleSelect = (num) => {
    setSelected(num);
  };

  const checkAnswer = () => {
    if (selected === questions[current].correct) {
      setResult('correct');
    } else {
      setResult('wrong');
    }
  };

  const nextQuestion = () => {
    setSelected('');
    setResult(null);
    setShowOptions(false);
    setCurrent(current + 1);
  };

  if (!surahParam) {
    return <div className="linking-test">لا يوجد سورة محددة</div>;
  }

  if (questions.length === 0) {
    return <div className="linking-test">جاري التحضير...</div>;
  }

  if (current >= questions.length) {
    return (
      <div className="linking-test">
      <div className="test-header">
        <div className="back-icon-container">
          <img
            className="back-icon"
            src={back}
            alt="back"
            onClick={() => navigate(-1)}
          />
        </div>
        <h1 className="test-title">اختبار الربط</h1>
      </div>
        <h2 className="surah-name">{surahName}</h2>
        <p>انتهى الاختبار</p>
        <BottomBar />
      </div>
    );
  }

  const q = questions[current];

  return (
    <div className="linking-test">
      <div className="test-header">
        <div className="back-icon-container">
          <img
            className="back-icon"
            src={back}
            alt="back"
            onClick={() => navigate(-1)}
          />
        </div>
        <h1 className="test-title">اختبار الربط</h1>
      </div>
      <h1>اختبار الربط</h1>
      <h2 className="surah-name">{surahName}</h2>
      <div className="question-ayah">{q.question}</div>
      {!showOptions && (
        <button
          className="show-options-button"
          onClick={() => setShowOptions(true)}
        >
          إظهار الخيارات
        </button>
      )}
      {showOptions && (
        <>
          <div className="options">
            {q.options.map((opt) => (
              <label
              key={opt.id}
              className={`option-item${selected === opt.id ? ' selected' : ''}`}
            >
                <input
                  type="radio"
                  name="option"
                  value={opt.id}
                  checked={selected === opt.id}
                  onChange={() => handleSelect(opt.id)}
                />
                <span>{opt.text}</span>
              </label>
            ))}
          </div>
          {result ? (
            <div>
              {result === 'correct' ? (
                <p className="correct">إجابة صحيحة</p>
              ) : (
                <p className="wrong">إجابة خاطئة</p>
              )}
              <button className="next-button" onClick={nextQuestion}>
                التالي
              </button>
            </div>
          ) : (
            <button
              className="check-button"
              onClick={checkAnswer}
              disabled={!selected}
            >
              تحقق
            </button>
          )}
        </>
      )}
      {/* <BottomBar /> */}
    </div>
  );
};

export default LinkingTest;